import {
    IProps,
} from './types';

import classNames from 'classnames';
import {
    formatAmount,
} from 'helpers';
import React, {
    FC,
} from 'react';

import {
    Card,
} from 'components/other';

import styles from './AmountCard.module.scss';

const AmountCard: FC<IProps> = (props) => {
    return (
        <Card className={classNames(styles.amountCard, props.className)}>
            <div className={styles.title}>
                Amount To Pay
            </div>
            <div className={styles.amount}>
                {`${props.currencySymbol}${formatAmount(props.amountKopecks)}`}
            </div>
        </Card>
    );
};

export default AmountCard;
